import { Routes } from '@angular/router';

import { clientRoutes } from '@flb/common/client-routes';
import { ReflowAggregatorService } from './leaderboard/reflow-aggregator.service.js';

export const routes: Routes = [
    {
        path: clientRoutes.root,
        loadChildren: () => import('./leaderboard/leaderboard-routes.js').then(m => m.routes),
        providers: [ReflowAggregatorService]
    },
    {
        path: clientRoutes.supportRequest.path,
        loadChildren: () =>
            import('./support-request/support-request-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.login.path,
        loadChildren: () => import('./admin-common/admin-common-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.admin.path,
        loadChildren: () => import('./admin/admin-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.analysis.path,
        loadChildren: () => import('./analysis/analysis-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.commentator.path,
        loadChildren: () => import('./commentator/commentator-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.diagnostics.path,
        loadChildren: () => import('./diagnostics/diagnostics-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.security.path,
        loadChildren: () => import('./security/security-routes.js').then(m => m.routes)
    },
    {
        path: clientRoutes.info.path,
        loadChildren: () => import('./info/info-routes.js').then(m => m.routes)
    }
];
